import React from "react";
import { FormControl, InputLabel, Select, MenuItem, SelectChangeEvent } from "@mui/material";
import { Staff } from "../../../../types/order";

interface StaffFilterProps {
  staffList: Staff[];
  selectedStaff: string;
  onStaffChange: (value: string) => void;
}

const StaffFilter: React.FC<StaffFilterProps> = ({ staffList, selectedStaff, onStaffChange }) => {
  const MenuProps = {
    PaperProps: {
      style: {
        maxHeight: 40 * 6.5,
        borderRadius: "8px",
      },
    },
  };

  return (
    <FormControl fullWidth size="small" variant="outlined">
      <InputLabel id="staff-label">Staff</InputLabel>

      <Select labelId="staff-label" label="Staff" value={selectedStaff} onChange={(e: SelectChangeEvent<string>) => onStaffChange(e.target.value)} className="rounded-xl" MenuProps={MenuProps}>
        <MenuItem value="">All Staff</MenuItem>

        {staffList.map((staff) => (
          <MenuItem key={staff.phone_number} value={staff.staff_name}>
            {staff.staff_name}
          </MenuItem>
        ))}
      </Select>
    </FormControl>
  );
};

export default StaffFilter;
